import React, { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PortalLayout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const linkStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    textDecoration: 'none',
    color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
    background: isActive ? 'rgba(255,255,255,0.15)' : 'transparent',
  });

  return (
    <div style={{ minHeight: '100vh', background: 'var(--gray-100)' }}>
      <nav style={{
        background: 'linear-gradient(135deg, #132a43 0%, #1b3a5c 100%)',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '56px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img src="/logo.png" alt="logo" style={{ width: '32px', height: '32px', borderRadius: '6px' }} />
            <span style={{ color: '#fff', fontWeight: 700, fontSize: '16px' }}>Data Portal</span>
          </div>
          <div style={{ display: 'flex', gap: '4px' }}>
            <NavLink to="/health" style={linkStyle}>System Health</NavLink>
            <NavLink to="/executive" style={linkStyle}>Executive View</NavLink>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '13px' }}>{user?.email}</span>
          <button
            onClick={handleLogout}
            style={{
              padding: '6px 14px',
              borderRadius: '6px',
              border: '1px solid rgba(255,255,255,0.3)',
              background: 'transparent',
              color: 'rgba(255,255,255,0.8)',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Sign Out
          </button>
        </div>
      </nav>
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '24px 20px' }}>
        {children}
      </main>
    </div>
  );
}
